import type { RefObject } from 'react';
import type { FlexProps } from '#core/components';
import { Flex } from '#core/components';

type TriggerProps = FlexProps &
  React.PropsWithChildren & {
    ref: RefObject<HTMLDivElement | null>;
  };

export const Trigger = ({ children, ...rest }: TriggerProps) => {
  return (
    <Flex flex={1} justifyContent="flex-end" position="relative" {...rest}>
      {children}
    </Flex>
  );
};
